<template>
  <div class="container">
    <div class="white-box text-center">关于我们</div>
  </div>
</template>

<script>
  export default {
    name: "PageAbout",
    props: ['isLogin'],
    data: function () {
      return {
        mobile : ''
      }
    },
    methods: {
      submit : function () {

      }
    },
    created: function () {
      console.info('page-about-init');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageAbout.vue